import React from "react";
import { FaSearch, FaRedo } from "react-icons/fa";
import { termOptions } from "../../utils/helper";
import Select from "../../components/Select/Select";
import Button from "../../components/Button/Button";

export const templateTypeOptions = [
  { id: 0, name: "Template" },
  { id: 1, name: "Excel" },
];

const TemplateFilter = ({ term, type, onChangeHandler, handleSearch, handleReset }) => {
  return (
    <div className="row mb-3">
      <div className="col-md-4">
        <Select
          label="Term"
          name="term"
          value={term}
          placeholder="Select Term"
          onChangeHandler={onChangeHandler}
          options={termOptions}
        />
      </div>
      <div className="col-md-4">
        <Select
          label="Type"
          name="type"
          value={type}
          placeholder="Select Type"
          onChangeHandler={onChangeHandler}
          options={templateTypeOptions}
        />
      </div>
      <div className="col-md-4">
        <label className="mb-1 mt-1 d-block invisible">Action</label>
        <div className="d-flex gap-2">
          <Button
            variant="primary"
            type="button"
            className="flex-fill"
            onClick={() => handleSearch({ selected: 0 })}
          >
            <FaSearch /> Search
          </Button>
          <Button
            variant="secondary"
            type="button"
            className="flex-fill"
            onClick={handleReset}
          >
            <FaRedo /> Reset
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TemplateFilter;
